/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Check_RunningInputs */

const en_auth_x15_check_running = /** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your browser with Cloudflare. This can take a few seconds.`)
};

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const ar_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const he_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const ur_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const es_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const fr_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const de_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const pt_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const hi_auth_x15_check_running = en_auth_x15_check_running;

/** @type {(inputs: Auth_X15_Check_RunningInputs) => LocalizedString} */
const bn_auth_x15_check_running = en_auth_x15_check_running;

/**
* | output |
* | --- |
* | "Checking your browser with Cloudflare. This can take a few seconds." |
*
* @param {Auth_X15_Check_RunningInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_x15_check_running = /** @type {((inputs?: Auth_X15_Check_RunningInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Check_RunningInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_x15_check_running(inputs)
	if (locale === "he") return he_auth_x15_check_running(inputs)
	if (locale === "ur") return ur_auth_x15_check_running(inputs)
	if (locale === "es") return es_auth_x15_check_running(inputs)
	if (locale === "fr") return fr_auth_x15_check_running(inputs)
	if (locale === "de") return de_auth_x15_check_running(inputs)
	if (locale === "pt") return pt_auth_x15_check_running(inputs)
	if (locale === "hi") return hi_auth_x15_check_running(inputs)
	if (locale === "bn") return bn_auth_x15_check_running(inputs)
	return /** @type {LocalizedString} */ ("Checking your browser with Cloudflare. This can take a few seconds.")
});